import { render, staticRenderFns } from "./preScreeningSingleCreate.vue?vue&type=template&id=468d0084&scoped=true&"
import script from "./preScreeningSingleCreate.vue?vue&type=script&lang=js&"
export * from "./preScreeningSingleCreate.vue?vue&type=script&lang=js&"
import style0 from "./preScreeningSingleCreate.vue?vue&type=style&index=0&id=468d0084&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468d0084",
  null
  
)

export default component.exports